/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Promotion } from './Promotion';
import {
    PromotionFromJSON,
    PromotionFromJSONTyped,
    PromotionToJSON,
} from './Promotion';
import type { PromotionOrderEntryConsumed } from './PromotionOrderEntryConsumed';
import {
    PromotionOrderEntryConsumedFromJSON,
    PromotionOrderEntryConsumedFromJSONTyped,
    PromotionOrderEntryConsumedToJSON,
} from './PromotionOrderEntryConsumed';

/**
 * Representation of a Promotion result
 * @export
 * @interface PromotionResult
 */
export interface PromotionResult {
    /**
     * Description of promotion result
     * @type {string}
     * @memberof PromotionResult
     */
    description?: string;
    /**
     * 
     * @type {Promotion}
     * @memberof PromotionResult
     */
    promotion?: Promotion;
    /**
     * List of promotion order entries consumed
     * @type {Array<PromotionOrderEntryConsumed>}
     * @memberof PromotionResult
     */
    consumedEntries?: Array<PromotionOrderEntryConsumed>;
}

/**
 * Check if a given object implements the PromotionResult interface.
 */
export function instanceOfPromotionResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PromotionResultFromJSON(json: any): PromotionResult {
    return PromotionResultFromJSONTyped(json, false);
}

export function PromotionResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): PromotionResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'description': !exists(json, 'description') ? undefined : json['description'],
        'promotion': !exists(json, 'promotion') ? undefined : PromotionFromJSON(json['promotion']),
        'consumedEntries': !exists(json, 'consumedEntries') ? undefined : ((json['consumedEntries'] as Array<any>).map(PromotionOrderEntryConsumedFromJSON)),
    };
}

export function PromotionResultToJSON(value?: PromotionResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'description': value.description,
        'promotion': PromotionToJSON(value.promotion),
        'consumedEntries': value.consumedEntries === undefined ? undefined : ((value.consumedEntries as Array<any>).map(PromotionOrderEntryConsumedToJSON)),
    };
}

